import { ref } from 'vue'
import { defineStore } from 'pinia'
import { UsersService, type TUser } from '@/types/generated'
import { useLocaleStore, supportedLocales, type Locale } from './localStore'

export const useUserStore = defineStore('userStore', () => {
  const user = ref<TUser>()

  async function fetchUser() {
    try {
      const response = await UsersService.usersRetrieve({ uuid: 'current' })
      user.value = response

      // Apply the effective language (user preferred -> org default -> 'de')
      const effectiveLanguage = response.effective_language
      if (effectiveLanguage && supportedLocales.includes(effectiveLanguage as Locale)) {
        const localeStore = useLocaleStore()
        localeStore.setLocale(effectiveLanguage as Locale)
      }

      return response
    } catch (error) {
      return null
    }
  }

  return {
    user,
    fetchUser
  }
})
